var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTariffChainBellFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00002 19.1429C9.26145 19.1429 10.2847 18.1197 10.2847 16.8572H5.71538C5.71538 18.1197 6.73859 19.1429 8.00002 19.1429ZM15.6926 13.7961C15.0025 13.0547 13.7114 11.9393 13.7114 8.28575C13.7114 5.51076 11.7657 3.28931 9.14217 2.74432V2.00003C9.14217 1.36896 8.63074 0.857178 8.00002 0.857178C7.36931 0.857178 6.85789 1.36896 6.85789 2.00003V2.74432C4.23431 3.28931 2.28859 5.51076 2.28859 8.28575C2.28859 11.9393 0.997524 13.0547 0.307525 13.7961C0.093239 14.0264 -0.00176102 14.3019 2.46923e-05 14.5715C0.00395327 15.1572 0.463597 15.7143 1.14646 15.7143H14.8536C15.5365 15.7143 15.9965 15.1572 16 14.5715C16.0018 14.3019 15.9069 14.0261 15.6926 13.7961Z",
    fill: "#AA8B4B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTariffChainBellFilled);
export default __webpack_public_path__ + "static/media/tariffChainBellFilled.22308092.svg";
export { ForwardRef as ReactComponent };